import { Button } from "@bpba/ui-components";

type SlideButtonProps = {
  text: string | undefined;
  includeMargin: boolean | undefined;
};

export function SlideButton({ text, includeMargin }: SlideButtonProps) {
  if (!text || text.trim().length === 0) return <></>;

  return (
    <Button variant={"white"} marginTop={includeMargin ? "24px" : "0px"}>
      <div dangerouslySetInnerHTML={getMarkup(text)} />
    </Button>
  );
}

function getMarkup(text?: string) {
  return { __html: text ?? "" };
}
